class SubCollectionCarousel extends HTMLElement {
  constructor() {
    super();

    this.carouselSelector = this.dataset.selector;
    this.collectionCarousel = this.querySelector(`#${this.carouselSelector}`);
  }

  connectedCallback() {
    const config = {
      dots: true,
      loop: false,
      arrows: true,
      autoplay: false,
      spaceBetween: 16,
      breakpoints: {
        320: {
          slidesPerView: 2.5,
          slidesPerGroup: 1,
        },
        480: {
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 3.5,
          slidesPerGroup: 1,
        },
        880: {
            slidesPerView: 4,
            slidesPerGroup: 1,
        }
      },
      navigation: {
        nextEl: this.querySelector(".swiper-arrow-carousel-next"),
        prevEl: this.querySelector(".swiper-arrow-carousel-prev"),
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
      }
    };

    new Swiper(this.collectionCarousel, config);
  }
}
customElements.define("subcollection-carousel", SubCollectionCarousel);
